import { render } from "./Basic.vue?vue&type=template&id=eecc2076"
import script from "./Basic.vue?vue&type=script&lang=ts"
export * from "./Basic.vue?vue&type=script&lang=ts"
script.render = render

export default script